<template>
  <div class="ui text container" id="conversor">
    <div class="ui hidden divider"></div>
    <div class="ui one column center aligned grid">
      <div class="row">
        <div class="ui basic fluid label top attached">
          Choose how much you want to buy
        </div>
        <div class="ui three equal width grid">
          <div class="ui column big input">
            <input type="number" v-model="dollar" v-on:input="setDollar">
            <span>USD</span>
          </div>
          <div class="ui column big input">
            <input type="number" v-model="ether" v-on:input="setEther">
            <span>ETH</span>
          </div>
          <div class="ui column big input">
            <input type="number" v-model="ant"  v-on:input="setANT">
            <span>ANT</span>
          </div>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <button class="ui huge center aligned fluid inverted basic button" v-bind:class="termsAccepted ? '' : 'disabled'" v-on:click="buyTokens">Buy tokens</button>
    </div>
  </div>
</template>

<script>
import config from '../config'
import getExchangeRate from '../lib/DollarEthRate'

const antEthRate = 100

export default {
  name: 'conversor',
  methods: {
    buyTokens() {
      if (this.$store.state.hadWeb3) {
        const amount = window.web3.toWei(this.ether, 'ether')
        window.web3.eth.getAccounts((err, accounts) => {
          const from = accounts[0]
          const txBody = { from, to: config.tokenAddress, value: amount, gas: 2e5 }
          window.web3.eth.sendTransaction(txBody, (e, x) => {
            if (e) alert(e)
            const etherscanUrl = `https://${config.etherscanPrefix}etherscan.io/tx/${x}`
            const win = window.open(etherscanUrl, '_blank')
            if (win) {
              win.focus()
            } else {
              alert(`Transaction sent, but your browser prevented opening a popup. Your transaction ID is: ${x} (${etherscanUrl})`)
            }
          })
        })
      } else {
        document.getElementById('tutorials').scrollIntoView()
      }
    },
    setDollar(e) {
      this.dollar = e.target.value
      getExchangeRate((rate) => {
        this.ether = e.target.value / rate
        this.ant = this.ether * antEthRate
      })
    },
    setEther(e) {
      this.ether = e.target.value
      this.ant = e.target.value * antEthRate
      getExchangeRate((rate) => {
        this.dollar = this.ether * rate
      })
    },
    setANT(e) {
      this.ant = e.target.value
      this.ether = e.target.value / antEthRate
      getExchangeRate((rate) => {
        this.dollar = this.ether * rate
      })
    },
  },
  data() {
    return {
      dollar: 0,
      ether: 1,
      ant: 0,
    }
  },
  computed: {
    termsAccepted() {
      return this.$store.state.termsAccepted
    },
  },
  mounted() {
    this.ant = this.ether * antEthRate
    getExchangeRate((rate) => {
      this.dollar = this.ether * rate
    })
  },
}
</script>

<style scoped>
#conversor {
  max-width: 40rem !important;
}
.grid {
  margin: 0;
}
.row {
  padding: 0 !important;
}
.row .column {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.attached.label {
  font-weight: lighter;
  border: none !important;
}
.input {
  padding: 0 !important;
}
.input span {
  position: absolute;
  top: 0 !important;
  display: inline-block;
  line-height: 4rem;
  vertical-align: middle;
  top: 1rem;
  right: 0.5rem;
  color: rgba(0, 0, 0, 0.5);
}
input {
  background: white;
  display: inline-block;
  color: #3b3b3b;
  padding-right: 3.25rem !important;
}
</style>



// WEBPACK FOOTER //
// Conversor.vue?23628b25